export const getRowId = (params: any) => {
    return params?.data?.field;
};
